module.exports = __webpack_public_path__ + "static/img/banner1.d53a4e1d.png";